import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { SVG } from '@core/consts/SVGs';

import { SignInFormComponent } from '../sign-in-form/sign-in-form.component';

@Component({
  selector: 'mdcr-sign-in-modal',
  imports: [SignInFormComponent, AngularSvgIconModule],
  templateUrl: './sign-in-modal.component.html',
  styleUrl: './sign-in-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInModalComponent {
  public SVG = SVG;
}
